import { ReactNode } from 'react';
import { motion } from 'framer-motion';

type MotionAccordionProps = {
  isOpen: boolean;
  initialHeight?: number;
  children: ReactNode;
};

const MotionAccordion = ({
  isOpen,
  initialHeight,
  children,
}: MotionAccordionProps) => {
  const animate = {
    transition: { type: 'tween' },
    height: isOpen ? 'auto' : initialHeight ? initialHeight : 0,
  };

  return (
    <motion.div
      style={{ overflow: 'hidden', padding: '0', cursor: 'pointer' }}
      initial={{ height: initialHeight ? initialHeight : 0, opacity: 1 }}
      animate={animate}
      exit={{ height: initialHeight ? initialHeight : 0, opacity: 1 }}
    >
      {children}
    </motion.div>
  );
};

export default MotionAccordion;
